import { WishlistResponse } from '@/hooks/useWishlist'

import { getOptional } from '../axios'

interface WishlistProps {
  url?: string
  userId?: number | undefined
  vendorId?: string
  locale?: string
  isprebook?: boolean
  page?: number
  pageSize?: number
}

const fetchWishlist = async ({
  url,
  userId,
  vendorId,
  locale,
  isprebook,
  page,
  pageSize,
}: WishlistProps) => {
  if (!url && (!userId || !vendorId)) {
    return undefined
  }

  return getOptional<WishlistResponse>(
    url ||
      `/hyperlocal/v1/wishlist/${userId}?vendor_id=${vendorId}&lang=${locale}&isprebook=${isprebook}&page_size=${pageSize}&page=${page}`,
  )
}

export default fetchWishlist
